import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initDB } from "./services/db";
import { initTheme } from "./hooks/useTheme";

// Apply saved theme immediately to prevent flash
initTheme();
import { initOfflineSync, processQueue } from "./services/offlineQueue";
import { initFeedbackQueueSync } from "./services/feedbackQueue";

// Initialize IndexedDB
initDB().then(() => {
  console.log('IndexedDB initialized');
}).catch((error) => {
  console.error('IndexedDB initialization failed:', error);
});

// Initialize offline sync
initOfflineSync();
initFeedbackQueueSync();

// Register Service Worker
// Im Dev-Mode überspringen UND aktive SWs entfernen — sonst caching von 503s + alter Bundles.
// Production: SW registrieren wie gehabt.
if ('serviceWorker' in navigator) {
  if (import.meta.env.DEV) {
    // Dev: alle bestehenden SWs unregistrieren, damit Hot-Reload zuverlässig durchkommt
    navigator.serviceWorker.getRegistrations().then((regs) => {
      regs.forEach((reg) => {
        reg.unregister().then((ok) => {
          if (ok) console.log('[dev] SW unregistered:', reg.scope);
        });
      });
    });
    // Auch alle Caches leeren — beseitigt 503-/Stale-Responses
    if ('caches' in window) {
      caches.keys().then((names) => {
        names.forEach((n) => caches.delete(n).then(() => console.log('[dev] cache cleared:', n)));
      });
    }
  } else {
    let refreshing = false;

    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (refreshing) return;
      refreshing = true;
      window.location.reload();
    });

    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/sw.js')
        .then((registration) => {
          console.log('SW registered:', registration.scope);

          if (registration.waiting) {
            registration.waiting.postMessage({ type: 'SKIP_WAITING' });
          }

          registration.addEventListener('updatefound', () => {
            const newWorker = registration.installing;
            if (!newWorker) return;

            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                newWorker.postMessage({ type: 'SKIP_WAITING' });
              }
            });
          });
        })
        .catch((error) => {
          console.error('SW registration failed:', error);
        });
    });

    // Listen for sync messages from SW
    navigator.serviceWorker.addEventListener('message', (event) => {
      if (event.data && event.data.type === 'SYNC_QUEUE') {
        processQueue();
      }
    });
  }
}

createRoot(document.getElementById("root")!).render(<App />);
